import React from 'react';
import {
  Box,
  Container,
  Grid,
  GridItem,
  Card,
  CardBody,
  VStack,
  Text,
  useColorModeValue,
  Flex,
  Circle,
  Image
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { serviceLinks } from '../../constants/navigationData';

const ServicesGrid = () => {
  const cardBg = useColorModeValue("white", "gray.800");
  const textColor = useColorModeValue("gray.600", "gray.300");
  const headingColor = useColorModeValue("#000B8C", "white");
  const navigate = useNavigate();

  const handleServiceClick = (link) => {
    navigate(link);
  };

  return (
    <Box
      py={{ base: 8, md: 12, lg: 16 }}
      sx={{
        backgroundImage: "url('/png/background.png')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <Container maxW="7xl">
        <Grid
          templateColumns={{
            base: "repeat(1, 1fr)",
            md: "repeat(2, 1fr)",
            lg: "repeat(3, 1fr)",
          }}
          gap={8}
          w="full"
        >
          {serviceLinks.map((service) => (
            <GridItem key={service.id}>
              <Card
                bg={cardBg}
                borderRadius="2xl"
                border="1px solid"
                borderColor="gray.100"
                transition="all 0.3s ease"
                _hover={{
                  bg: "blue.50",
                  "& .service-title": {
                    color: "blue.700"
                  },
                  "& .service-description": {
                    color: "#000B8C"
                  },
                  "& .service-icon": {
                    color: "#000B8C"
                  },
                  "& .service-arrow": {
                    bg: "blue.100",
                    color: "#000B8C"
                  }
                }}
                cursor="pointer"
                h="full"
                onClick={() => handleServiceClick(service.href)}
              >
                <CardBody p={8}>
                  <VStack align="flex-start" spacing={6} h="full">
                    {/* Icon */}
                    <Box
                      p={0}
                      borderRadius="xl"
                      transition="all 0.3s ease"
                    >
                      <Image
                        src={service.image}
                        alt={service.title}
                        w={8}
                        h={8}
                        className="service-icon"
                        transition="all 0.3s ease"
                      />
                    </Box>

                    {/* Content */}
                    <VStack align="flex-start" spacing={4} flex="1">
                      <Text
                        fontSize={{ base: "xl", md: "2xl" }}
                        color={headingColor}
                        className="service-title"
                        lineHeight="1.3"
                        transition="color 0.3s ease"
                      >
                        {service.title}
                      </Text>
                      <Text
                        color={textColor}
                        className="service-description"
                        fontSize="md"
                        lineHeight="1.6"
                        flex="1"
                        noOfLines={3}
                        transition="color 0.3s ease"
                      >
                        {service.description}
                      </Text>
                    </VStack>

                    {/* Arrow Button */}
                    <Flex justify="flex-end" w="full" mt="auto">
                      <Circle
                        size="48px"
                        bg="gray.100"
                        color="gray.600"
                        className="service-arrow"
                        transition="all 0.3s ease"
                        cursor="pointer"
                        onClick={(e) => {
                          e.stopPropagation();
                          navigate(service.href);
                        }}
                      >
                        <Image
                          src="/png/corner-arrow.png"
                          w={5}
                          h={5}
                          objectFit="cover"
                        />
                      </Circle>
                    </Flex>
                  </VStack>
                </CardBody>
              </Card>
            </GridItem>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default ServicesGrid;